

import { baseUrl_SPB} from '../BaseUrl';
export default  async function AddCompanyService(formData, token) {
     let tokenv=token.toString();
        try {
            const response = await fetch(`${baseUrl_SPB}/api/v1/invite/createcompanyandrootuser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + tokenv
                },
                body: JSON.stringify(formData),
            });
            const jsonResponse = await response.json();
            return jsonResponse;
        } catch (error) {
            console.error('Error:', error);
        }
    }
   



